import {
  Container,
  Stack,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getAllHistory } from "../../../api";
import { DataGrid } from "@mui/x-data-grid";
import { grid_columns } from "../utils";
import moment from "moment/moment";

export default function AllHistory() {
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState();
  const [rows, setRows] = useState([]);
  const [columnsEdited, setColumnsEdited] = useState([]);
  const [isloading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAllHistory();
        setHistoryData(result);
        setIsLoading(false);
      } catch (error) {}
    };
    fetchData();
  }, []);

  useEffect(() => {
    let table_rows = [];
    if (historyData?.length > 0) {
      historyData?.map((reading) => {
        let row = {
          id: reading?.id,
          title:
            reading?.title === null || reading?.title === ""
              ? "-"
              : reading.title,
          description: reading?.description,
          updated_at:
            reading?.updated_at !== null
              ? moment(reading.updated_at).format("DD/MM/YYYY")
              : "-",
          is_deleted: reading?.is_deleted,
        };
        return table_rows.push(row);
      });
    }

    setRows(table_rows);
  }, [historyData]);

  useEffect(() => {
    let columns_array = [...grid_columns];
    let itemName = grid_columns?.filter(
      (element) => element?.field === "title"
    )[0];

    let indexName = columns_array?.indexOf(itemName);

    itemName = {
      ...itemName,
      renderCell: (params) => (
        <Box
          sx={{ cursor: "pointer", "&:hover": { color: "primary.main" } }}
          onClick={() => handleNavigate(params?.row?.id)}
        >
          {params?.row?.title}
        </Box>
      ),
    };

    columns_array[indexName] = itemName;

    setColumnsEdited(columns_array);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const handleNavigate = (id) => {
    navigate("/history/edit", {
      state: {
        historyId: id,
      },
    });
  };

  return (
    <Container>
      <Stack
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "100%", sm: "100%" },
        }}
      >
        <Card>
          <CardContent>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={5}
            >
              <Typography variant="h4">History</Typography>

              <Button
                variant="contained"
                color="primary"
                style={{
                  fontSize: "14px",
                  fontFamily: "sans-serif",
                  fontWeight: 700,
                  textTransform: "initial",
                }}
                startIcon={<AddIcon />}
                onClick={() => navigate("/history/create-new")}
              >
                New
              </Button>
            </Stack>

            <DataGrid
              rows={rows}
              columns={columnsEdited}
              loading={isloading}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              disableRowSelectionOnClick
              sx={{
                "& .MuiDataGrid-cellContent": {
                  whiteSpace: "break-spaces",
                  paddingY: 1,
                },
                "& .MuiDataGrid-columnHeaders": {
                  bgcolor: "background.neutral",
                  borderRadius: 0,
                  color: "text.secondary",
                },
                "& .MuiDataGrid-iconSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter":
                  {
                    display: "none",
                  },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus":
                  {
                    outline: "none !important",
                  },
                "& .MuiDataGrid-overlayWrapper": {
                  minHeight: "200px",
                },
              }}
            />
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
